export default "__VITE_ASSET__d2ea8250__"